import React from "react";
import locales from "../locales";
import {Divider, Icon} from "antd";

interface Props {
  options: React.ReactNode;
  addItem?: () => void;
}

class DropdownRender extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  public render(): React.ReactNode {
    const {options, addItem} = this.props;

    return (
      <div>
        {options}
        <Divider style={{margin: '4px 0'}}/>
        <div
          style={{padding: '4px 8px', cursor: 'pointer'}}
          onMouseDown={this.preventDefault}
          onClick={addItem}
        >
          <Icon type="plus"/>{locales.add}
        </div>
      </div>
    )
  };

  private preventDefault(e: React.MouseEvent<HTMLDivElement>) {
    e.preventDefault();
  }
}

export default DropdownRender;



// WEBPACK FOOTER //
// ./src/common/DropdownRender.tsx